import { setRangeMax } from './helpers';

export const setUndergroundTravelTime = setRangeMax('foot_min');
